import * as actionTypes from 'constants/ActionTypes';

const links = (state = {
    items: [],
    isLoaded: false,
}, action) => {
    switch (action.type) {
    case actionTypes.GET_ANALYTICS_LINKS_LIST.REQUEST:
        return {
            ...state,
        };
    case actionTypes.GET_ANALYTICS_LINKS_LIST.SUCCESS: {
        return {
            ...state,
            items: action.data,
            isLoaded: true,
        };
    }
    case actionTypes.GET_ANALYTICS_LINKS_LIST.FAILURE:
        return {
            ...state,
            isLoaded: true,
        };

    default:
        return state;
    }
};

export default links;



// WEBPACK FOOTER //
// ./app/reducers/analytics/linksList.js